/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import '../style/page_01.scss'
import { format } from '../config'
class Page01 extends React.Component {
  constructor(props) {
    super();
    this.state = {
      isEnter: false
    }
  }

  scrollPage = () => {
    window.$('html,body').animate({
      scrollTop: 1600
    }, 1000);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLoadingEnter !== this.props.isLoadingEnter && this.props.isLoadingEnter) {
      this.entranceDom.play();
    }
  }

  componentDidMount() {
    this.entranceDom.addEventListener('ended', () => {
      this.loopDom.play();
      this.setState({ isEnter: true })
      this.props.showSideProgress()
    })
  }

  render() {
    return (
      <div className="page page_01">
        <video style={{ 'display': this.state.isEnter ? 'none' : 'block' }} src={this.props.entranceUrl} muted ref={(ref) => { this.entranceDom = ref; }}></video>
        <video style={{ 'display': this.state.isEnter ? 'block' : 'none' }} src={this.props.loopUrl} loop muted ref={(ref) => { this.loopDom = ref; }}></video>
        <a href="https://blood.web.sdo.com" target="_blank" rel="noopener noreferrer" className="logo"></a>
        <div className="top-nav">
          <a className="home" target="_blank" rel="noopener noreferrer" href="https://blood.web.sdo.com"></a>
          <div className="gift-info">
            <div className="top-qrcode"></div>
          </div>
        </div>
        <div className="btn-container">
          <div className={`reserve-btn ${this.props.phone ? 'reserved' : ''}`} onClick={this.props.toggleReservePop}></div>
          <div className="expose-btn" onClick={this.scrollPage}></div>
        </div>
        <div className="count-container">
          <p>全平台已有<span>{format(this.props.count)}</span>位血裔预约集结</p>
        </div>
        {this.props.phone && <div className="login-info">
          <div className="shadow"></div>
          <p>手机<span>{this.props.phone}</span>已登陆。<span style={{ cursor: 'pointer' }} onClick={this.props.logOut}>「 注销 」</span></p>
        </div>}
        <div className="cover"></div>
      </div>
    )
  }
}

export default Page01;
